import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "@delibrandev/utils/src/styles.css";

import "./visual-polish.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  // Evita un crash raro si falta el div#root por algún motivo
  console.error('No se encontró el elemento "#root" en el DOM.');
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}
